module.exports = __webpack_public_path__ + "static/media/favourite.6735919f.svg";